/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Button, Row, Col, Tabs, Alert, Popconfirm } from 'antd';
import { isEmpty } from 'underscore';
import AccountPermissions from './tabs/AccountPermissions';
import AssetPermissions from './tabs/AssetPermissions';
import DriverPermissions from './tabs/DriverPermissions';
import Layout from '../../components/layout/Layout';
import FilterSidebar from '../../components/FilterSidebar';
import LeftSide from './partials/LeftSide';
import Avatar from '../../components/elements/Avatar';
import { UserRole } from '../../types/types';

export default function () {
    const {
        user, departments, divisions, userId, isFetching
    } = this.props;
    const {
        currentTabKey,
    } = this.state;

    const filterContent = null;
    let assetPermissionsTabComponent = null;
    let accountPermissionsTabComponent = null;
    let driverPermissionsTabComponent = null;
    if (currentTabKey === '1') {
        accountPermissionsTabComponent = (
            <AccountPermissions userId={userId} />
        );
    } else if (currentTabKey === '2') {
        assetPermissionsTabComponent = (
            <AssetPermissions userId={userId} />
        );
    } else if (currentTabKey === '3') {
        driverPermissionsTabComponent = (
            <DriverPermissions userId={userId} />
        );
    }

    return (
        <Layout
            data-test="pages-users-view"
            className="drivers-view"
            title={<div>UserView</div>}
            headerTitle={<div>UserView Page</div>}
            showFooter={false}
            loading={isFetching}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                {filterContent && (
                    <FilterSidebar>
                        {filterContent}
                    </FilterSidebar>
                )}
                <div
                    className="content"
                >
                    <div className="content-inner">
                        <section className="section">
                            <br />
                            <br />
                            <div className="section__body">
                                <div className="top-section">
                                    <div className="actions__buttons">
                                        <Button
                                            type="primary"
                                            className="page-header-button"
                                            style={{
                                                top: '-32px',
                                                right: '-32px',
                                            }}
                                            onClick={this.updateProfile}
                                        >
                                            <span>Save</span>
                                        </Button>
                                        <Button
                                            type="primary"
                                            className="page-header-button"
                                            style={{
                                                top: '-32px',
                                                right: '52px',
                                            }}
                                            onClick={() => this.props.history.push(`/users/copy-user/${userId}`)}
                                        >
                                            <span>Copy</span>
                                        </Button>
                                        <Popconfirm
                                            title={`Are you sure you want to delete "${user.userDetail.name}"?`}
                                            onConfirm={e => {
                                                const { actions } = this.props;
                                                e.stopPropagation();
                                                actions.deleteUserRequest({ user_id: userId });
                                            }}
                                            onCancel={e => e.stopPropagation()}
                                            okText="Delete"
                                            cancelText="Cancel"
                                        >
                                            <Button
                                                type="primary"
                                                className="page-header-button"
                                                style={{
                                                    top: '-32px',
                                                    right: '140px',
                                                }}
                                            >
                                                <span>Delete</span>
                                            </Button>
                                        </Popconfirm>
                                    </div>
                                </div>
                                <Row
                                    gutter={40}
                                    type="flex"
                                    justify="space-between"
                                    className="data-row"
                                >
                                    <Col xl={6}>
                                        {!isEmpty(user.userDetail) ? (
                                            <LeftSide
                                                currentUserRole={user.role}
                                                profile={user.userDetail}
                                                departments={departments}
                                                divisions={divisions}
                                                registerGetDetailsHandler={(f) => { this.getAccountDetails = f; }}
                                            />
                                        ) : null}
                                    </Col>
                                    <Col xl={11}>
                                        <div className="actions">
                                            <Row
                                                type="flex"
                                                gutter={40}
                                                justify="space-between"
                                            >
                                                <Col>
                                                    <br />
                                                    <Avatar
                                                        pictureUrl={user.userDetail.profilePictureFull}
                                                        onChange={(data) => this.updateDriverPicture(data)}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                                <Tabs
                                    onTabClick={(key) => this.setState({ currentTabKey: key })}
                                    defaultActiveKey="1"
                                    animated={false}
                                    className="tabs-restyled2"
                                >
                                    <Tabs.TabPane
                                        tab="Account Permissions"
                                        key="1"
                                    >
                                        <div className="section__body">
                                            <div style={{ height: 20 }} />
                                            {[UserRole.SuperAdmin, UserRole.Admin, UserRole.Manager, UserRole.SalesAdmin].includes(user.userDetail.role) ? (
                                                <Alert message="Info" description="Admins, Super-Admins and Managers have all account permissions" type="info" />
                                            ) : accountPermissionsTabComponent}
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane
                                        tab="Asset Permissions"
                                        key="2"
                                    >
                                        <div className="section__body">
                                            <div style={{ height: 20 }} />
                                            {[UserRole.SuperAdmin, UserRole.Admin, UserRole.SalesAdmin].includes(user.userDetail.role) ? (
                                                <Alert message="Info" description="Admins and Super-Admins have all division permissions" type="info" />
                                            ) : assetPermissionsTabComponent}
                                        </div>
                                    </Tabs.TabPane>
                                    <Tabs.TabPane
                                        tab="Driver Permissions"
                                        key="3"
                                    >
                                        <div className="section__body">
                                            <div style={{ height: 20 }} />
                                            {[UserRole.SuperAdmin, UserRole.Admin, UserRole.SalesAdmin].includes(user.userDetail.role) ? (
                                                <Alert message="Info" description="Admins, Super-Admins and Managers have all driver permissions" type="info" />
                                            ) : driverPermissionsTabComponent}
                                        </div>
                                    </Tabs.TabPane>
                                </Tabs>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
